import CONSTANTS from 'utils/constants';
import _ from 'ckLodash';
import classCommand from 'commands/classCommand';
import elementUtils from 'utils/elementUtils';
import selectionUtils from 'utils/selectionUtils';
import styleCommand from 'commands/styleCommand';

function createColorClasses(prefix) {
    var classNames = [];
    var i;

    for (i = 0; i <= 65; i++) {
        classNames.push(prefix + i);
    }

    return classNames;
}

var hexRegEx = new RegExp(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/);

function refreshCommand(commandName, editor, elementPath) {
    editor.getCommand(commandName).refresh(editor, elementPath);
}

function getCommandState(editor, commandName) {
    return editor.getCommand(commandName).state;
}

function ColorCommand(inlineCommandName, classCommandName) {
    this.inlineCommandName = inlineCommandName;
    this.classCommandName = classCommandName;
}

ColorCommand.prototype = {
    contextSensitive: true, //Config CK to call refresh the command after selection change
    exec: function (editor, params) {
        var originalFocus = {};

        if (!this.editorFocus) {
            originalFocus.classCommand = editor.getCommand(this.classCommandName).editorFocus;
            originalFocus.inlineCommand = editor.getCommand(this.inlineCommandName).editorFocus;

            editor.getCommand(this.classCommandName).editorFocus = this.editorFocus;
            editor.getCommand(this.inlineCommandName).editorFocus = this.editorFocus;
        }

        editor.undoManager.lock(true);
        try {
            params = _.isString(params) ? CKEDITOR.tools.convertRgbToHex(params) : params;
            if (hexRegEx.test(params)) {
                editor.execCommand(this.classCommandName, CKEDITOR.TRISTATE_OFF);
                editor.execCommand(this.inlineCommandName, params);
            } else {
                editor.execCommand(this.inlineCommandName, CKEDITOR.TRISTATE_OFF);
                editor.execCommand(this.classCommandName, params);
            }
            _.forEach(selectionUtils.getSelectedLists(editor), listElement => {
                this.applyOnElement(params, listElement);
            });
        } finally {
            editor.undoManager.unlock();

            if (!this.editorFocus) {
                editor.getCommand(this.classCommandName).editorFocus = originalFocus.classCommand;
                editor.getCommand(this.inlineCommandName).editorFocus = originalFocus.inlineCommand;
            }
        }
    },
    refresh: function (editor, elementPath) {
        refreshCommand(this.inlineCommandName, editor, elementPath);
        var colorValue = getCommandState(editor, this.inlineCommandName);
        if (colorValue !== CKEDITOR.TRISTATE_OFF) {
            if (!hexRegEx.test(colorValue)) {
                colorValue = CKEDITOR.tools.convertRgbToHex(colorValue);
            }
            this.setState(colorValue.toUpperCase());
        } else {
            refreshCommand(this.classCommandName, editor, elementPath);
            this.setState(getCommandState(editor, this.classCommandName));
        }
    },
    applyOnElement: function (value, element) {
        if (this.name !== 'forecolor') {
            return;
        }

        element.removeStyle('color');
        elementUtils.removeClassesWithPrefix(element, 'color_');

        if (hexRegEx.test(value)) {
            element.setStyle('color', value);
        } else if (value !== CKEDITOR.TRISTATE_OFF) {
            element.addClass(value);
        }
    }
};

function backColorChildRule(element) {
    // guard should allways be allowed to be child
    //todo - move to guard utils isGuard(element)
    var cssClass = element.getAttribute && element.getAttribute('class');
    if (cssClass && cssClass.indexOf('wixGuard') !== -1) {
        return true;
    }

    if (element.getName && element.getName() === 'br') {
        return true;
    }

    // back color should be near the text so font-size will be above it in the dom
    return false;
}

function initForeColorCommand(editor) {
    editor.addCommand('foreColorInline', new styleCommand('span', 'color'));
    editor.addCommand('foreColorClass', new classCommand('span', createColorClasses(CONSTANTS.COLOR_CLASS_PREFIX), 'foreColorClass'));
    editor.addCommand('foreColor', new ColorCommand('foreColorInline', 'foreColorClass'));
}

function initBackColorCommand(editor) {
    editor.addCommand('backColorInline', new styleCommand('span', 'background-color', {childRule: backColorChildRule}));
    editor.addCommand('backColorClass', new classCommand('span', createColorClasses(CONSTANTS.BACKCOLOR_CLASS_PREFIX), 'backColorClass', backColorChildRule));
    editor.addCommand('backColor', new ColorCommand('backColorInline', 'backColorClass'));
}

export default {
    initForeColorCommand: initForeColorCommand,
    initBackColorCommand: initBackColorCommand
};
